export enum GlobalSearchType {
    UNKNOWN,
    CONTACT,
    SERVICE
}